import { Location } from 'history';
import qs from 'qs';

// Returns an object with keys and values from the browser URL query string
export default (location: Location) => {
  const { search } = location;
  const queryString = search.split('?')[1];
  return qs.parse(queryString);
};
